import { List } from 'antd';

import { Schemas } from '@api-client/generated/types';

import BillingListEmpty from '../BillingListEmpty';
import BillingListItem from '../BillingListItem';

type BillingListPeriods = {
  type: 'period';
  dataSource: Schemas.BillingPeriod[];
  onAdd: VoidFunction;
  selectedId?: string;
};

type BillingListOneTimeInvoices = {
  type: 'one-time';
  isDisabled?: boolean;
  dataSource: Schemas.BillingDocument[];
  onAdd: VoidFunction;
  selectedId?: string;
};

type BillingListProps = BillingListPeriods | BillingListOneTimeInvoices;

const BillingList = (props: BillingListProps) => {
  if (!props.dataSource.length) {
    return (
      <BillingListEmpty
        isDisabled={props.type === 'one-time' && props.isDisabled}
        type={props.type}
        onAdd={props.onAdd}
      />
    );
  }

  switch (props.type) {
    case 'period':
      return (
        <List
          dataSource={props.dataSource}
          renderItem={(item) => (
            <BillingListItem
              type={props.type}
              selectedId={props.selectedId}
              details={item}
            />
          )}
        />
      );
    case 'one-time':
      return (
        <List
          dataSource={props.dataSource}
          renderItem={(item) => (
            <BillingListItem
              type={props.type}
              selectedId={props.selectedId}
              details={item}
            />
          )}
        />
      );
  }
};

export default BillingList;
